export default __webpack_public_path__ + "static/media/port-terminal.886fa38e.png";